<template>
    <!--防骗指南-->
    <!--导航栏-->
    <ZhaiHead></ZhaiHead>
    <!--导航栏-->
    <!--主体-->
    <div class="container-fluid zhu px-0">
        <div class="row shengse">
            <div class="dixian px-4 py-2 d-flex justify-content-between">
                <div>防骗指南</div>
            </div>
            <div class="p-3 gohome">
                <h1>为了让广大用户避免上当受骗，大家做到以下几点，基本可以有效预防。</h1>
                <h1>防骗第一条：凡是要求预付定金/保证金的，都是骗子！</h1>
                <h1>防骗第二条：联系之前先通过下方说明查询该联系方式</h1>
                <p style="color: #00c26f;">
                    本站为VIP用户提供了 <a href="/queryAccount">联系方式查询</a> 功能，通过联系方式查询，可以查到与该联系方式匹配的所有帖子，以及用户反馈。可以有效避坑、防骗。当你准备联系之前（包括从其他途径得到的联系方式），请务必通过此功能查询，查询结果将优先展示带有用户反馈的帖子。
                </p>
                <p>
                    一、如果妹子是自己租公寓或者小区里的房子，打听一下房子的租金就可以知道妹子做这个生意的成本大概是多少，依据这个可判断是不是坑。不熟悉的妹子千万不要选择上门，因为没有自己承租地方做这个生意的，大概率都是骗子。
                </p>
                <p>
                    二、未见面，拒绝提前支付任何费用！！！如车费、定金、安全保证金、预付一半费用、付全款后才见面等各种理由的费用（如给红包发照片，给红包视频，定位到楼下付款，其他人代收款等），切勿因为已开房或其他费用，因小失大，不停给对方打款，越陷越深。
                </p>
                <p>
                    三、见面后，确认为所预约的人，付费给妹子，或当着妹子的面付给中间人，付费后禁止对方以任何理由离开房间，如有必要离开，请随行，或要求对方退款后，方可离开。
                </p>
                <p>
                    四、见面后，人照不符的，不满意的，可以拒绝接受服务，或给车费让他走。如是平台认证的帖子，差距大的，不满意的，请立即联系管理员处理。并及时联系平台在线客服。
                </p>
                <p>
                    五、到店服务的，和描述不一致，直接离开。进店后，问清楚服务项目。确认有服务，选到满意技师，再交费或服务后再交费。模糊介绍服务，为选人先交费，要求办卡才有服务的，请立即离开，并联系平台反馈。
                </p>
                <p>
                    六、可以提前百度一下对方的联系方式，看是否有人曾被骗。
                </p>
                <p>
                    七、拒绝支付任何平台旗号的费用。
                </p>
            </div>

        </div>
    </div>
    <!--主体-->
    <!--公共底部-->
    <ZhaiFoot></ZhaiFoot>
    <!--公共底部-->

</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";

    export default {
        name: "MAvoidFraud",
        components:{ ZhaiHead, ZhaiFoot}
    }
</script>

<style scoped>
    /*顶部占据空间*/
    .gongxi{
        height: 90px;
    }
    /*文本的样式*/
    .gohome h1 {
        font-size: 1.5rem;
        margin-top: 2rem;
        color: #00c26f;
        padding-left: 15px;
        padding-right: 15px;
    }
    .gohome p {
        font-size: 1rem;
        padding: 1rem 0;
        color: #000;
        line-height: 2rem;
        padding-left: 15px;
        padding-right: 15px;
    }
    .zhu{
        margin-top: 80px;
    }


</style>